import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { CustomButton } from '../../../../layout/styledcomponents/CustomButton';
import { CustomIconButton } from '../../../../layout/styledcomponents/CustomIconButton';
import ExpenseModal from '../../Reservations/ExpenseClaims/ExpenseModal';
import { useAddExpenseClaimMutation } from '../../../../app/Slices/SevenDayApiSlice';
import { handleHttpError } from '../../../../shared/utils';
import toast from '../../../shared/Toast';

export default function ExpenseClaimsHero(params: {
    expenses: {
        src: string;
        id: string;
        uuid: string;
        name: string;
        createdAt: string;
        addedBy: { firstName: string; lastName: string };
    }[];
}) {
    const { expenses } = params;
    const isMobile = useMediaQuery('(max-width: 770px)');
    const [addNewExpenseClaim] = useAddExpenseClaimMutation();
    const theme = useTheme();

    const [showExpenseModal, setShowExpenseModal] = useState(false);

    const handleOpenExpenseModal = () => {
        setShowExpenseModal(true);
    };

    const handleNewExpense = (data: any) => {
        addNewExpenseClaim(data)
            .unwrap()
            .then((data: any) => {
                if (data?.error) {
                    const errorMessage = handleHttpError(data?.error);
                    toast.error(errorMessage);
                } else {
                    toast.success(`Successfully added expense`);
                    setShowExpenseModal(false);
                }
            })
            .catch(() => {
                toast.error('Failed to add expense Please try again.');
            });
    };

    return (
        <Grid
            sx={{
                textAlign: ' right',
                paddingBottom: '10px',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: isMobile ? '0' : '10px',
            }}
        >
            {isMobile ? (
                <CustomIconButton
                    variant='contained'
                    color='primary'
                    onClick={() => {
                        handleOpenExpenseModal();
                    }}
                    sx={{
                        '&:hover': {
                            cursor: 'pointer',
                            color: theme.palette.textAccent.main,
                            backgroundColor: 'transparent',
                            background: 'none',
                        },
                    }}
                >
                    <AddCircleIcon />
                </CustomIconButton>
            ) : (
                <CustomButton
                    variant='contained'
                    color='primary'
                    startIcon={<AddCircleIcon />}
                    onClick={() => {
                        handleOpenExpenseModal();
                    }}
                >
                    Add Expense
                </CustomButton>
            )}
            <ExpenseModal
                open={showExpenseModal}
                onClose={() => setShowExpenseModal(false)}
                expenses={expenses}
                onSubmit={handleNewExpense}
                isEditing={false}
            />
        </Grid>
    );
}
